<template>
  <v-menu>
    <template #activator="{ on: menu }">
      <span style="position: relative; cursor: pointer !important">
        <span v-if="readonly">
          <slot></slot>
        </span>
        <span v-else v-on="menu">
          <slot></slot>
        </span>
        <template v-if="!noicon">
          <em
            v-if="outtericon"
            style="color: grey; position: absolute; right: -18px; top: 2px"
            class="fas fa-chevron-down"
          ></em>
          <em
            v-else
            style="color: grey; position: absolute; right: 10px; top: 8px"
            class="fas fa-chevron-down"
          ></em>
        </template>
      </span>
    </template>
    <v-list style="max-height: 400px; overflow: auto">
      <v-list-tile
        v-for="(item, index) in filteredOptions"
        :key="index"
        :style="{
          opacity: options[index].disabled ? 0.8 : 1,
          pointerEvents: options[index].disabled ? 'none' : 'auto'
        }"
        dense
        class="rsu"
        @click="selectedMenu(index)"
      >
        <v-list-tile-title :style="{ fontWeight: value == item ? 600 : 400 }">{{
          item
        }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    textLabel: {
      type: String,
      default: null
    },
    textValue: {
      type: String,
      default: null
    },
    readonly: {
      default: false
    },
    outtericon: {
      default: false
    },
    noicon: {
      default: false
    }
  },
  computed: {
    filteredOptions() {
      if (this.textLabel) {
        return this.options.map((el) => {
          return el[this.textLabel]
        })
      } else {
        return this.options
      }
    }
  },
  methods: {
    selectedMenu(index) {
      if (!this.readonly) {
        if (this.textValue) {
          this.$emit('input', this.options[index][this.textValue])
          this.$emit('change', this.options[index][this.textValue])
        } else {
          this.$emit('input', this.options[index])
          this.$emit('change', this.options[index])
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/DropdownMenu.vue